import { useAxios } from "@hooks";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Question } from "@types";
import { App } from "antd";
import { useTranslation } from "react-i18next";

export const useDeleteExamGroupQuestions = (groupId?: string) => {

    const axios = useAxios();
    const { t } = useTranslation();
    const queryClient = useQueryClient();
    const { message } = App.useApp();

    const deleteExamGroupQuestions = async (questions: Question[]) => {
        const values = {
            groupId: groupId,
            questionsOrder: questions.map(q => ({ questionId: q.id, orderNumber: q.orderNumber }))
        }
        try {
            await axios.post(`/api/examgroup/deletequestions`, values);
        } catch (error) {
            throw new Error(t("messages.error.deleteExamGroupQuestion"));
        }
    }

    return useMutation({
        mutationFn: deleteExamGroupQuestions,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["examGroupQuestions"] });
            queryClient.invalidateQueries({ queryKey: ["examGroups"] });
            message.success(t("messages.success.deleteExamGroupQuestion"));
        },
    });
}